import { Component } from '@angular/core';

import { QuillModules } from 'ngx-quill';
import { FormFieldComponent } from '../form-field.types';
import { getQuillTextAreaToolbarModules } from '@shared/Utils/quill-editor.utils';

@Component({
  templateUrl: './textarea-form-field.component.html',
  styles: [
    `
      :host ::ng-deep .textarea-quill-editor .ql-editor {
        @apply h-auto w-full overflow-auto resize-y;
        min-height: 180px;
        max-height: 500px;
      }

      .disabled {
        color: #6e6e6e !important;
        pointer-events: none;
        opacity: 0.8;
        cursor: not-allowed !important;
      }
    `,
  ],
})
export class TextAreaFormFieldComponent extends FormFieldComponent {
  private _originalValue: string;

  public quillModules: QuillModules;
  public editing: boolean = false;
  public value: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.quillModules = getQuillTextAreaToolbarModules(this.isDisabled);

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
